import Navbar from "./components/Navbar";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Career from "./components/Career";

function App() {
    return (
        <div>
            <Navbar />
            <About />
            <Career />
            <Projects />
            <Skills />
        </div>
    );
}

export default App;
